import { ChangeDetectionStrategy, Component } from "@angular/core";

interface DocumentationResource {
  title: string;
  description: string;
  icon: string;
  url?: string;
}

interface DocumentationSection {
  title: string;
  description: string;
  resources: readonly DocumentationResource[];
}

@Component({
  selector: "app-lab-documentation",
  standalone: true,
  imports: [],
  templateUrl: "./lab-documentation.component.html",
  styleUrl: "./lab-documentation.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabDocumentationComponent {
  readonly sections = LAB_DOCUMENTATION_SECTIONS;
}

export const LAB_DOCUMENTATION_SECTIONS: readonly DocumentationSection[] = [
  {
    title: "Lab Operations",
    description: "Frequently used laboratory records and working documents.",
    resources: [
      {
        title: "Calibrations",
        description: "Calibration records and supporting documentation.",
        icon: "fa-sliders",
        url: "https://chevron.sharepoint.com/sites/DrillingMudandCement/Cement%20Lab/Forms/Main.aspx?id=%2Fsites%2FDrillingMudandCement%2FCement%20Lab%2FCalibrations&viewid=64ecdce0%2D52a6%2D41dd%2D8b04%2D17ec77f42e68",
      },
      {
        title: "Lab Worksheets",
        description: "Laboratory worksheets used during daily operations.",
        icon: "fa-table",
        url: "https://chevron.sharepoint.com/sites/DrillingMudandCement/Cement%20Lab/Forms/Main.aspx?id=%2Fsites%2FDrillingMudandCement%2FCement%20Lab%2FLab%20Worksheets&viewid=64ecdce0%2D52a6%2D41dd%2D8b04%2D17ec77f42e68&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMjAyMjguMjAxODgiLCAiT1MiIDogIldpbmRvd3MiIH0%3D",
      },
      {
        title: "Chemical Inventory",
        description: "Laboratory inventory records and reference lists.",
        icon: "fa-cubes",
        url: "https://chevron.sharepoint.com/sites/DrillingMudandCement/Cement%20Lab/Forms/Main.aspx?d=wdcd3859058d94cbda7d16c2957adab46&csf=1&web=1&e=IxnY7e&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMjAyMjguMjAxODgiLCAiT1MiIDogIldpbmRvd3MiIH0%3D&CID=d4db39a2%2De02a%2Df000%2D5210%2Dcf8def162fa5&cidOR=SPO&FolderCTID=0x012000DB329DC187F99649A50251F6DB893591&id=%2Fsites%2FDrillingMudandCement%2FCement%20Lab%2FChemical%20Inventory",
      },
    ],
  },
  {
    title: "Safety and Compliance",
    description: "Safety data, standards, and approved operating procedures.",
    resources: [
      {
        title: "SDS",
        description: "Material safety data sheets and GHS safety documentation.",
        icon: "fa-shield",
        url: "https://chevron.sharepoint.com/sites/DrillingMudandCement/Cement%20Lab/Forms/Main.aspx?e=5%3Af07669e4ee1541ddb6bc00fcd6c64c5e&sharingv2=true&fromShare=true&at=9&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMjAyMjguMjAxODgiLCAiT1MiIDogIldpbmRvd3MiIH0%3D&CID=ccdb39a2%2D20cb%2Df000%2D5210%2Dc9912e23f9c6&cidOR=SPO&FolderCTID=0x012000DB329DC187F99649A50251F6DB893591&id=%2Fsites%2FDrillingMudandCement%2FCement%20Lab%2FMSDS%20and%20GHS%20SDS",
      },
      {
        title: "Safety - Final SOPs",
        description: "Approved final versions of safety procedures.",
        icon: "fa-check-square-o",
        url: "https://chevron.sharepoint.com/sites/DrillingMudandCement/Cement%20Lab/Forms/Main.aspx?d=wc30b0882a1645543b516a7d4fa7c0227&csf=1&web=1&e=r5VbzN&clickparams=eyAiWC1BcHBOYW1lIiA6ICJNaWNyb3NvZnQgT3V0bG9vayIsICJYLUFwcFZlcnNpb24iIDogIjE2LjAuMjAyMjguMjAxODgiLCAiT1MiIDogIldpbmRvd3MiIH0%3D&CID=d3db39a2%2Dc092%2De000%2Dec48%2Defe91fcdf2ff&cidOR=SPO&FolderCTID=0x012000DB329DC187F99649A50251F6DB893591&id=%2Fsites%2FDrillingMudandCement%2FCement%20Lab%2FSafety%2FFinal%20SOPs",
      },
    ],
  },
];